import React, { FC } from 'react';
import { PollsViewStatuses } from '../../../../constans/polls-constants';
import { convertStatusIntoClassName } from '../../../../utils/helpers/polls-helper';
import completed_icon from '../../../../assets/icons/ok.svg';
import { observer } from 'mobx-react';
import './poll-status.scss';

interface IProps {
  status: PollsViewStatuses;
  additionalClassName?: string;
}

const PollStatus: FC<IProps> = ({ status, additionalClassName }) => {
  const filteredStatus = status === PollsViewStatuses.RESETED ? PollsViewStatuses.COMPLETED : status;

  return (
    <span className={`poll-status--${convertStatusIntoClassName(filteredStatus)} ${additionalClassName || ''}`}>
      {filteredStatus === PollsViewStatuses.COMPLETED && <img src={completed_icon} alt='completed icon'/>}
      {filteredStatus}
    </span>
  );
};

export default observer(PollStatus);